/**
 * Centred card frame for `/auth/*` (login, register).
 *
 * A deliberate, scoped exception to the rest of the app's Carbon conversion:
 * the user asked for a specific rounded/gradient/soft-shadow "front door"
 * look by example (a screenshot of another product), confirmed to apply only
 * to these two auth pages — everything past login stays Carbon. So this
 * layout, `LoginPage.tsx` and `RegisterPage.tsx` intentionally do NOT use
 * Carbon's `Grid`/`Tile`/`TextInput`/`Button` — their own small design
 * system lives in carbon.scss under the `.auth-hero*` rules (kept in that
 * file for one build, not a separate one, since it is not itself Carbon).
 */
import { Building } from '@carbon/icons-react';
import { Link, Outlet } from 'react-router-dom';
import { ROUTES } from '../routes/paths';
import { ThemeToggle } from '../components/ThemeToggle';

export function AuthLayout(): React.JSX.Element {
  return (
    <div className="auth-hero">
      <div className="auth-hero__glow auth-hero__glow--one" aria-hidden="true" />
      <div className="auth-hero__glow auth-hero__glow--two" aria-hidden="true" />

      <main className="auth-hero__card">
        <ThemeToggle />

        <Link to={ROUTES.landing} className="auth-hero__brand">
          <span className="auth-hero__logo" aria-hidden="true">
            <Building size={20} />
          </span>
          <span>
            <span className="auth-hero__brand-name">Rent Management</span>
            <span className="auth-hero__brand-tag">Property management platform</span>
          </span>
        </Link>

        <Outlet />
      </main>
    </div>
  );
}

export default AuthLayout;
